export enum QuestionType {
  SingleInput = "SingleInput",
  FoundersInput = "FoundersInput",
  SharesInput = "SharesInput",
  CommitmentInput = "CommitmentInput",
  ResponsibilitiesInput = "ResponsibilitiesInput",
  LeaversInput = "LeaversInput",
  BadAfterVestingInput = "BadAfterVestingInput",
  CallOptionsInput = "CallOptionsInput",
  VestingDurationInput = "VestingDurationInput",
  VestingStartInput = "VestingStartInput",
  VestingSharesInput = "VestingSharesInput",
  VestingFrequencyInput = "VestingFrequencyInput",
  VestingCliffInput = "VestingCliffInput",
}

export enum LeaversType {
  Early = "Early",
  Good = "Good",
  Bad = "Bad",
}

export enum CallOptionsType {
  Early = "Early",
  Good = "Good",
  Bad = "Bad",
}

export const Phases = [
  {
    id: 0,
    name: "Basic information",
    position: 0,
  },
  {
    id: 1,
    name: "Vesting info",
    position: 1,
  },
  {
    id: 2,
    name: "Leavers info",
    position: 2,
  },
  {
    id: 3,
    name: "Call options",
    position: 3,
  },
  {
    id: 4,
    name: "Deliverables",
    position: 4,
  },
];

export const SubPhases = [
  {
    id: 0,
    name: "Name",
    phase: 0,
    position: 0,
  },
  {
    id: 1,
    name: "Founders",
    phase: 0,
    position: 1,
  },
  {
    id: 3,
    name: "Shares",
    phase: 0,
    position: 3,
  },
  {
    id: 2,
    name: "Time Commitment",
    phase: 0,
    position: 2,
  },
  {
    id: 4,
    name: "Responsibilities",
    phase: 0,
    position: 4,
  },
  {
    id: 5,
    name: "Duration",
    phase: 1,
    position: 0,
  },
  {
    id: 6,
    name: "Start",
    phase: 1,
    position: 1,
  },
  {
    id: 15,
    name: "Shares",
    phase: 1,
    position: 2,
  },
  {
    id: 7,
    name: "Frequency",
    phase: 1,
    position: 3,
  },
  {
    id: 8,
    name: "Cliff",
    phase: 1,
    position: 4,
  },
  {
    id: 9,
    name: "Good",
    phase: 2,
    position: 0,
  },
  {
    id: 10,
    name: "Early",
    phase: 2,
    position: 1,
  },
  {
    id: 11,
    name: "Bad",
    phase: 2,
    position: 2,
  },
  {
    id: 16,
    name: "Bad after vesting",
    phase: 2,
    position: 3,
  },
  {
    id: 12,
    name: "Good",
    phase: 3,
    position: 0,
  },
  {
    id: 13,
    name: "Early",
    phase: 3,
    position: 1,
  },
  {
    id: 14,
    name: "Bad",
    phase: 3,
    position: 2,
  },
];

export const GivenQuestions = [
  {
    id: 0,
    phase: 0,
    subPhase: 0,
    question: "What is the name of the company?",
    questionType: QuestionType.SingleInput,
    label: "Legal company name",
    moreInfo: false,
  },
  {
    id: 1,
    phase: 0,
    subPhase: 1,
    question: "Who are the founders?",
    questionType: QuestionType.FoundersInput,
    moreInfo: false,
  },
  {
    id: 2,
    phase: 0,
    subPhase: 3,
    question: "How are the shares divided?",
    questionType: QuestionType.SharesInput,
    dependsOn: 1,
    moreInfo: false,
  },
  {
    id: 3,
    phase: 0,
    subPhase: 2,
    question: "What is the expected time commitment?",
    questionType: QuestionType.CommitmentInput,
    dependsOn: 1,
    moreInfo: true,
  },
  {
    id: 4,
    phase: 0,
    subPhase: 4,
    question: "What are the responsibilities and roles of the founders?",
    questionType: QuestionType.ResponsibilitiesInput,
    dependsOn: 1,
    moreInfo: true,
  },
  {
    id: 5,
    phase: 1,
    subPhase: 5,
    question:
      "How long do the founders need to work for the company before they have earned their shares?",
    questionType: QuestionType.VestingDurationInput,
    moreInfo: true,
  },
  {
    id: 6,
    phase: 1,
    subPhase: 6,
    question: "As of which date do you start earning your shares?",
    questionType: QuestionType.VestingStartInput,
    dependsOn: 1,
    moreInfo: true,
  },
  {
    id: 15,
    phase: 1,
    subPhase: 15,
    question: "All shares should be earned?",
    questionType: QuestionType.VestingSharesInput,
    dependsOn: 1,
    moreInfo: true,
  },
  {
    id: 7,
    phase: 1,
    subPhase: 7,
    question: "At which pace should the shares vest?",
    questionType: QuestionType.VestingFrequencyInput,
    moreInfo: true,
  },
  {
    id: 8,
    phase: 1,
    subPhase: 8,
    question: "Should there be a cliff in your vesting schedule?",
    questionType: QuestionType.VestingCliffInput,
    moreInfo: true,
  },
  {
    id: 9,
    phase: 2,
    subPhase: 9,
    question: "When are you a good leaver?",
    questionType: QuestionType.LeaversInput,
    default: ["Death", "Permanent disablement"],
    type: LeaversType.Good,
    title: "Good leaver events",
    titleRight: "Add Good leaver events (optional)",
    moreInfo: true,
    labelExplanation:
      "Mental illness and physical illness are optional leaver events that you can mark as a ‘good leaver event’ or an ‘early leaver event’. Note that if for example: you mark ‘mental illness’ as a ‘good leaver event’, you wont be able to mark it also as an ‘early leaver event.",
  },
  {
    id: 10,
    phase: 2,
    subPhase: 10,
    question: "When are you an early leaver?",
    questionType: QuestionType.LeaversInput,
    default: ["Early termination", "Time commitment"],
    type: LeaversType.Early,
    title: "Early leaver events",
    titleRight: "Add Early leaver events (optional)",
    labelExplanation:
      "Mental illness and physical illness are optional leaver events that you can mark as a ‘good leaver event’ or an ‘early leaver event’. Note that if for example: you mark ‘mental illness’ as an ‘early leaver event’, you wont be able to mark it also as a ‘good leaver event.",
    moreInfo: true,
  },
  {
    id: 11,
    phase: 2,
    subPhase: 11,
    question: "When are you a bad leaver?",
    questionType: QuestionType.LeaversInput,
    default: [
      "Fraud",
      "Severe criminal offense",
      "Gross fault",
      "Violation of non compete",
    ],
    type: LeaversType.Bad,
    title: "Bad leaver events",
    titleRight: "",
    labelExplanation: "",
    moreInfo: true,
  },
  {
    id: 16,
    phase: 2,
    subPhase: 16,
    question:
      "Should it be possible to be a bad leaver after the vesting period?",
    questionType: QuestionType.BadAfterVestingInput,
    moreInfo: true,
  },
  {
    id: 12,
    phase: 3,
    subPhase: 12,
    question:
      "Call options for the remaining founder(s) on the shares of the good leaving founder?",
    questionType: QuestionType.CallOptionsInput,
    type: CallOptionsType.Good,
    moreInfo: true,
  },
  {
    id: 13,
    phase: 3,
    subPhase: 13,
    question:
      "Call options for the remaining founder(s) on the shares of the early leaving founder?",
    questionType: QuestionType.CallOptionsInput,
    type: CallOptionsType.Early,
    moreInfo: true,
  },
  {
    id: 14,
    phase: 3,
    subPhase: 14,
    dependsOn: 16,
    question:
      "Call options for the remaining founder(s) on the shares of the bad leaving founder?",
    questionType: QuestionType.CallOptionsInput,
    type: CallOptionsType.Bad,
    moreInfo: true,
  },
];

export enum SlideName {
  CompanyAndShares = "CompanyAndShares",
  Slide1 = "Slide1",
  Slide2 = "Slide2",
  Slide3 = "Slide3",
  Slide4 = "Slide4",
  Slide5Part1 = "Slide5Part1",
  Slide5Part2 = "Slide5Part2",
  Slide6 = "Slide6",
  Slide8 = "Slide8",
}

export type Slide1Type = {
  id: number;
  foundersQuestionId: number;
  companyQuestionId: number;
  position: number;
};

export type Slide2Type = {
  id: number;
  resultType: SlideName.Slide2;
  companyQuestionId: number;
  foundersQuestionId: number;
  sharesQuestionId: number;
  vestingSharesId: number;
  position: number;
};

export type Slide3Type = {
  id: number;
  resultType: SlideName.Slide3;
  foundersQuestionId: number;
  vestingDurationId: number;
  timeCommitmentId: number;
  position: number;
};

export type Slide4Type = {
  id: number;
  resultType: SlideName.Slide4;
  foundersQuestionId: number;
  rolesResponsibilitiesId: number;
  position: number;
};

export type Slide5Part1Type = {
  id: number;
  resultType: SlideName.Slide5Part1;
  leaverEventGoodId: number;
  leaverEventEarlyId: number;
  leaverEventBadId: number;

  position: number;
};

export type Slide5Part2Type = {
  id: number;
  resultType: SlideName.Slide5Part2;
  position: number;
};

export type Slide6Type = {
  id: number;
  resultType: SlideName.Slide6;
  vestingFrequencyId: number;
  vestingDurationId: number;
  vestingCliffId: number;
  vestingStartId: number;
  foundersQuestionId: number;
  callOptionsGoodId: number;
  callOptionsEarlyId: number;
  callOptionsBadId: number;
  badAfterVestingId: number;
  vestingSharesId: number;
  position: number;
};

export type Slide8Type = {
  id: number;
  resultType: SlideName.Slide8;
  vestingFrequencyId: number;
  vestingDurationId: number;
  vestingCliffId: number;
  vestingStartId: number;
  foundersQuestionId: number;
  callOptionsGoodId: number;
  callOptionsEarlyId: number;
  callOptionsBadId: number;
  badAfterVestingId: number;
  vestingSharesId: number;
  position: number;
};

export const Results = [
  {
    id: 0,
    resultType: SlideName.Slide1,
    companyQuestionId: 0,
    foundersQuestionId: 1,
    position: 0,
  },
  {
    id: 5,
    resultType: SlideName.Slide2,
    companyQuestionId: 0,
    foundersQuestionId: 1,
    sharesQuestionId: 2,
    vestingSharesId: 15,
    position: 1,
  },
  {
    id: 3,
    resultType: SlideName.Slide3,
    foundersQuestionId: 1,
    timeCommitmentId: 3,
    vestingDurationId: 5,
    position: 2,
  },
  {
    id: 1,
    resultType: SlideName.Slide4,
    foundersQuestionId: 1,
    rolesResponsibilitiesId: 4,
    position: 3,
  },
  {
    id: 4,
    resultType: SlideName.Slide5Part1,
    leaverEventGoodId: 9,
    leaverEventEarlyId: 10,
    leaverEventBadId: 11,
    position: 4,
  },
  {
    id: 5,
    resultType: SlideName.Slide5Part2,
    leaverEventGoodId: 9,
    leaverEventEarlyId: 10,
    leaverEventBadId: 11,
    position: 5,
  },
  {
    id: 2,
    resultType: SlideName.Slide6,
    foundersQuestionId: 1,
    vestingDurationId: 5,
    vestingStartId: 6,
    vestingFrequencyId: 7,
    vestingCliffId: 8,
    callOptionsGoodId: 12,
    callOptionsEarlyId: 13,
    callOptionsBadId: 14,
    badAfterVestingId: 16,
    vestingSharesId: 15,
    position: 6,
  },
  {
    id: 6,
    resultType: SlideName.Slide8,
    foundersQuestionId: 1,
    vestingDurationId: 5,
    vestingStartId: 6,
    vestingFrequencyId: 7,
    vestingCliffId: 8,
    callOptionsGoodId: 12,
    callOptionsEarlyId: 13,
    callOptionsBadId: 14,
    badAfterVestingId: 16,
    vestingSharesId: 15,
    position: 7,
  },
];
